import { render, staticRenderFns } from "./VerFechamentosParticulares.vue?vue&type=template&id=5a5e9678&"
import script from "./VerFechamentosParticulares.vue?vue&type=script&lang=js&"
export * from "./VerFechamentosParticulares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports